export default "__VITE_ASSET__DitjF0MD__"